import React from 'react';
import { Box, Typography } from '@mui/material';
import { MARKER_STYLES } from '../../constants/mapConfig';

export interface MapLegendProps {
  placesCount: number;
  placeStatusesCount: number;
  loading: boolean;
}

const MapLegend = ({
  placesCount,
  placeStatusesCount,
  loading,
}: MapLegendProps): JSX.Element => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 10,
        left: 10,
        zIndex: 1000,
        background: 'white',
        padding: '10px',
        fontSize: '12px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      <Typography variant="body2" sx={{ marginBottom: '8px', fontWeight: 'bold' }}>
        Place Status Legend
      </Typography>
      
      {/* Place Status Legend */}
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: '#28a745',
            marginRight: '6px',
            border: '3px solid #1a1a1a',
          }}
        />
        <Typography variant="caption">Selected (thick dark border)</Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: '#28a745',
            marginRight: '6px',
            border: '1px solid #3388ff',
          }}
        />
        <Typography variant="caption">Enabled</Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: '#dc3545',
            marginRight: '6px',
            border: '1px solid #3388ff',
          }}
        />
        <Typography variant="caption">Disabled</Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: '#3388ff',
            marginRight: '6px',
            border: '1px solid #ccc',
          }}
        />
        <Typography variant="caption">Unknown</Typography>
      </Box>

      {/* Drop Point Markers Legend */}
      <Typography variant="body2" sx={{ marginBottom: '6px', fontWeight: 'bold', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
        Drop Point Markers
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: MARKER_STYLES.VERIFIED_COLOR,
            borderRadius: '50%',
            marginRight: '6px',
            border: '2px solid white',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
          }}
        />
        <Typography variant="caption">Verified</Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: MARKER_STYLES.UNVERIFIED_COLOR,
            borderRadius: '50%',
            marginRight: '6px',
            border: '2px solid white',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
          }}
        />
        <Typography variant="caption">Unverified</Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: MARKER_STYLES.DELETED_COLOR,
            borderRadius: '50%',
            marginRight: '6px',
            border: '2px solid white',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
            opacity: 0.6,
          }}
        />
        <Typography variant="caption">Deleted</Typography>
      </Box>

      {/* Status Info */}
      <Box sx={{ borderTop: '1px solid #ccc', paddingTop: '8px', fontSize: '11px', color: '#666' }}>
        <Typography variant="caption">
          Places: {placesCount}, Cached Status: {placeStatusesCount}, Loading: {loading ? 'Yes' : 'No'}
        </Typography>
      </Box>
    </Box>
  );
};

export default MapLegend;
